import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { UsersPage, UsersEditPage } from './users';

export default function Users() {
  return (
    <Routes>
      <Route path=':type' element={<UsersPage />} />
      <Route path='' element={<UsersPage />} />
    </Routes>
  );
}
